export default __webpack_public_path__ + "static/media/Comp 2_00007.76cf602b.png";